/** Routes that use the marketing / landing navbar and no dashboard sidebar, even when logged in. */
const PUBLIC_MARKETING_EXACT = [
  '/',
  '/login',
  '/register',
  '/pricing',
  '/blog',
  '/contact',
  '/welcome',
  '/start',
  '/start/complete',
  '/workspace-not-found',
  '/verify-email',
  '/issue-verify-email',
]

export function isPublicMarketingRoute(path) {
  if (!path) return false
  if (PUBLIC_MARKETING_EXACT.includes(path)) return true
  if (path.startsWith('/start/')) return true
  return path.startsWith('/legal')
}